import React from 'react';
import { Users, Award, Globe, Shield, Zap, HeadphonesIcon } from 'lucide-react';

const Team = () => {
  const reasons = [
    {
      icon: Award,
      title: 'Compañía referente',
      description: 'Somos una compañía referente en tecnología que avanza a gran velocidad integrando las últimas soluciones tecnológicas.'
    },
    {
      icon: Users,
      title: 'Expertos en tecnología',
      description: 'Contamos con un equipo de más de 50 expertos en desarrollo, cloud e IA con certificaciones internacionales.'
    },
    {
      icon: Globe,
      title: 'Personalización',
      description: 'Nuestro amplio conocimiento nos permite ofrecer soluciones adaptadas a las necesidades específicas de cada cliente.'
    },
    {
      icon: Zap,
      title: 'Capacidad tecnológica',
      description: 'Como proveedores globales de tecnología, estamos preparados para ofrecer la solución que cada negocio necesita.'
    },
    {
      icon: Shield,
      title: 'Certificaciones',
      description: 'Somos partners de los líderes del mercado: AWS, Microsoft Azure y Google Cloud Platform.'
    },
    {
      icon: HeadphonesIcon,
      title: 'Soporte y formación',
      description: 'Te ayudamos a aprovechar todo el potencial de la tecnología con servicios de soporte, asesoramiento y formación.'
    }
  ];

  const testimonials = [
    {
      name: 'Carlos Rodríguez',
      role: 'Head of Engineering',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e',
      quote: 'Aplicamos tecnologías de vanguardia para posicionar a nuestros clientes como líderes en innovación y transformación digital.'
    },
    {
      name: 'María González',
      role: 'Head of Cloud & AI',
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2',
      quote: 'Integramos soluciones de Cloud e IA para transformar la forma en que nuestros clientes operan y toman decisiones.'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Por qué cloudexpert.cl
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            La combinación perfecta de experiencia, tecnología y compromiso con tu éxito
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div
                key={index}
                className="bg-gradient-to-br from-white to-white rounded-xl p-8 border border-gray-200 hover:border-[#ff6b35] transition-all duration-300 hover:shadow-xl hover:shadow-[#ff6b35]/10"
              >
                <div className="inline-flex items-center justify-center w-14 h-14 bg-orange-50 rounded-lg mb-4">
                  <Icon className="w-7 h-7 text-[#ff6b35]" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{reason.title}</h3>
                <p className="text-gray-600 leading-relaxed">{reason.description}</p>
              </div>
            );
          })}
        </div>

        {/* Testimonials */}
        <div className="mb-20">
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Quienes hacen posible nuestro éxito
          </h3>
          <div className="grid md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-white to-white rounded-2xl p-8 border border-gray-200 hover:border-[#ff6b35] transition-all duration-300"
              >
                <div className="flex items-center gap-4 mb-6">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover border-2 border-[#ff6b35]"
                  />
                  <div>
                    <h4 className="text-xl font-bold text-gray-900">{testimonial.name}</h4>
                    <p className="text-[#ff6b35]">{testimonial.role}</p>
                  </div>
                </div>
                <blockquote className="text-gray-600 text-lg leading-relaxed italic">
                  "{testimonial.quote}"
                </blockquote>
              </div>
            ))}
          </div>
        </div>

        {/* Team Image */}
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c"
            alt="Equipo cloudexpert.cl"
            className="w-full h-96 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-50/80 to-transparent flex items-center">
            <div className="px-12">
              <h3 className="text-4xl font-bold text-gray-900 mb-4">
                Un equipo comprometido con tu éxito
              </h3>
              <p className="text-xl text-gray-700 max-w-2xl">
                Más de 50 profesionales especializados trabajando para transformar tu negocio
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;